module.exports = __webpack_public_path__ + "static/media/kocka4POMOZIBA.83943db4.png";